import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { formatDate } from '@angular/common';
import { MODAL_DATA } from '../../../helpers/modal.tokens';
import { ApiwrapperService } from '../../../services/apiwrapper.service';
import { DataManipulationService } from '../../../services/data-manipulation.service';

export interface DownloadReportModalData {
  teamUuid: string;
  requirePayment: string;
  myTeamRole: number;
}

@Component({
  selector: 'app-download-report-modal',
  templateUrl: './download-report-modal.component.html',
  styleUrls: ['./download-report-modal.component.scss']
})
export class DownloadReportModalComponent {
  @ViewChild('exportButtonDownload') exportButtonDownload!: ElementRef<HTMLAnchorElement>;
  startDate: Date = new Date();
  endDate: Date = new Date();
  canExport: boolean;
  showUpgradeTooltip: boolean;

  constructor(@Inject(MODAL_DATA) private config: DownloadReportModalData,
              private dialogRef: MatDialogRef<any>,
              private api: ApiwrapperService,
              private data: DataManipulationService) {
    this.canExport = config.requirePayment === 'yes' && config.myTeamRole > 10;
    this.showUpgradeTooltip = config.requirePayment !== 'yes';
  }

  close() {
    this.dialogRef.close();
  }

  getModalDate() {
    if (this.startDate === null) {
      this.data.showAlertError('Please select the first date')
    } else if (this.endDate === null) {
      this.data.showAlertError('Please select a second date')
    } else {
      this.data.showLoading();
      this.api.getTeamIndicatorsExport(formatDate(this.startDate, 'dd-MM-yyyy', 'en-US'), formatDate(this.endDate, 'dd-MM-yyyy', 'en-US'), this.config.teamUuid).subscribe(
        res => {
          setTimeout(() => {
            this.exportButtonDownload.nativeElement.href = res.file;
            this.exportButtonDownload.nativeElement.click();
            this.close();
            this.data.hideLoading();
          }, 500);
        }, err => {
          console.log(err);
          this.data.showAlertError('Error on exporting the data')
        }
      );
    }
  }
}
